import React, { useEffect, useState } from "react";
import './Form.css';

const Form = () => {
    const [usage, setUsage] = useState('');

    const removeActiveButtonClass = (usage) => {
        if (usage == 'onetime')
            document.getElementById('onetime').classList.remove('activeButton');
        else if (usage == 'recurring') 
            document.getElementById('recurring').classList.remove('activeButton');
    }
    

    return (
        <div className="container-fluid form-outside-container">
            <div className="container">
                <p className="form-heading">help us find the best space for you</p>
                <div className="row justify-content-center">
                    <div className="col-xl-5 col-lg-8 col-md-10 col-sm-12 col-12">
                        <form>
                            <label htmlFor="fullname">Full Name</label>
                            <br />
                            <input type="text" name="fullname" id="fullname" />
                            <br />
                            <br />
                            <label htmlFor="email">Email-id</label>
                            <br />
                            <input type="email" name="email" id="email" />
                            <br /><br />
                            <label htmlFor="contact">Contact Number</label>
                            <br />
                            <input type="tel" name="contact" id="contact" />
                            <br /><br />
                            <label htmlFor="organization">Organization Name</label>
                            <br />
                            <input type="text" name="organization" id="organization" />
                            <br /><br />
                            <div>
                                <label htmlFor="purpose">Purpose</label>
                                <label htmlFor="occupancy">Occupancy</label>
                            </div>
                            <div>
                            <input type="text" name="purpose" id="purpose" />
                            <input type="text" name="occupancy" id="occupancy" />
                            </div>
                            <br />
                            <label htmlFor="usage">Usage</label>
                            <div className="usage">
                                <button onClick={(e) => {
                                    e.preventDefault();
                                    if (usage == 'onetime') {
                                        setUsage('')
                                        removeActiveButtonClass('onetime')
                                        return;
                                    }

                                    else if (usage == 'recurring') {
                                        removeActiveButtonClass('recurring');
                                    }

                                    setUsage('onetime');
                                    document.getElementById('onetime').classList.add('activeButton');
                                }} id='onetime'>
                                    One-Time
                                </button>
                                <button onClick={(e) => {
                                    e.preventDefault();
                                    if (usage == 'recurring') {
                                        setUsage('')
                                        removeActiveButtonClass('recurring')
                                        return;
                                    }

                                    else if (usage == 'onetime') {
                                        removeActiveButtonClass('onetime');
                                    }

                                    setUsage('recurring');
                                    document.getElementById('recurring').classList.add('activeButton');
                                }} id='recurring'>
                                    Recurring
                                </button>
                            </div>
                            <br />
                            <button className="form-submit-btn">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Form;